import React, { useState, useRef, useEffect } from 'react';

const AvailabilitySchedule = ({ handleBookClick, name }) => {
  const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const timeSlots = ['6 PM - 7 PM', '7 PM - 8 PM', '8 PM - 9 PM', '9 PM - 10 PM', '10 PM - 11 PM'];

  const [activeDay, setActiveDay] = useState('Mon');
  const [selectedTimes, setSelectedTimes] = useState({
    Mon: [],
    Tue: [],
    Wed: [],
    Thu: [],
    Fri: [],
    Sat: [],
    Sun: [],
  });

  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const containerRef = useRef(null);
  const tabsRef = useRef([]);

  const updateIndicator = () => {
    const selectedTab = tabsRef.current[daysOfWeek.indexOf(activeDay)];
    const container = containerRef.current;

    if (selectedTab && container) {
      const containerScrollLeft = container.scrollLeft;
      const { offsetLeft, offsetWidth } = selectedTab;
      setIndicatorStyle({
        left: offsetLeft - containerScrollLeft,
        width: offsetWidth,
      });
    }
  };

  useEffect(() => {
    updateIndicator();
  }, [activeDay]);

  const handleDayClick = (day) => {
    setActiveDay(day);
  };

  const handleTimeClick = (time) => {
    setSelectedTimes((prev) => {
      const dayTimes = prev[activeDay];
      const newDayTimes = dayTimes.includes(time)
        ? dayTimes.filter((t) => t !== time)
        : [...dayTimes, time];

      return {
        ...prev,
        [activeDay]: newDayTimes,
      };
    });
  };

  const isBookButtonDisabled = !Object.values(selectedTimes).some((times) => times.length > 0);

  return (
    <div className="flex h-full flex-1 flex-col rounded-3xl bg-white pb-8 pt-10 ">
      <div className="mb-[34.5px] flex flex-col">
        <h2 className="fredokaOne mb-[31px] text-center text-[40px] font-normal leading-normal tracking-[-0.8px] text-[#012E33]">
          {name}&apos;s Availability
        </h2>

        <div className="relative  border-b" ref={containerRef}>
          <div className="flex justify-between border-b px-12">
            {daysOfWeek.map((day, idx) => (
              <button
                key={day}
                ref={(el) => (tabsRef.current[idx] = el)}
                onClick={() => handleDayClick(day)}
                className={`relative px-2 pt-1 pb-[15px]  text-sm font-medium transition-colors
                                ${activeDay === day ? 'text-teal-500' : 'text-gray-400'}`}
              >
                {day}
              </button>
            ))}
          </div>
          {/* Indicator */}
          <div
            className="absolute -bottom-0 h-0.5 bg-teal-500 transition-all duration-300 ease-in-out"
            style={indicatorStyle}
          />
        </div>
      </div>

      {/* Time slots for active day */}
      <div className="mx-auto flex-1">
        <div className="mb-8  flex max-w-[469px] flex-1 flex-wrap justify-center gap-2 self-center px-[53px]">
          {timeSlots.map((time) => (
            <button
              key={time}
              onClick={() => handleTimeClick(time)}
              className={`px-4 py-2 rounded-full border text-sm transition-all
                            ${
                              selectedTimes[activeDay].includes(time)
                                ? 'border-teal-500 bg-teal-500 text-white'
                                : 'border-gray-300 text-gray-600 hover:border-teal-500'
                            }`}
            >
              {time}
            </button>
          ))}
        </div>
      </div>
      {/* Book button */}
      <button
        onClick={handleBookClick}
        disabled={isBookButtonDisabled}
        className={`mx-auto flex flex-shrink-0 items-center justify-center gap-2 rounded-[16px] p-2 px-6 shadow-[inset_0px_1px_2px_0px_rgba(255,255,255,0.40),inset_0px_4px_4px_0px_rgba(255,255,255,0.35)]  ${isBookButtonDisabled ? 'bg-[#D9DFDF] ' : 'bg-[#FC823E] text-white'}`}
      >
        Book slot
      </button>
    </div>
  );
};

export default AvailabilitySchedule;
